(function ($) {
  'use strict';

  var CART_TRIGGER_SELECTORS = [
    '.js-cart-trigger',
    '[data-open="CartDrawer"]',
    '[href="#CartDrawer"]',
    '.js-cart-count',
    '[data-trigger="cart"]'
  ];

  var state = 'idle';
  var pendingQuickShopEl = null;
  var fallbackTimer = null;
  var addingToCart = false; 

  function getCartTrigger() {
    for (var i = 0; i < CART_TRIGGER_SELECTORS.length; i++) {
      var $el = $(CART_TRIGGER_SELECTORS[i]);
      if ($el.length) return $el.first();
    }
    return null;
  }

  function openCartDrawer() {
    var $trigger = getCartTrigger();
    if ($trigger) {
      $trigger.trigger('click');
    } else {
      console.warn('[cart-draw-quickshop]  No cart drawer. Add selector into CART_TRIGGER_SELECTORS.');
    }
  }

  function onQuickShopClosed() {
    if (state !== 'quickshop-open') return;
    state = 'idle';
    clearTimeout(fallbackTimer);

    $(document.body).one('afterCartLoad.ajaxCart', function () {
      clearTimeout(fallbackTimer);
      setTimeout(openCartDrawer, 150);
    });

    fallbackTimer = setTimeout(function () {
      openCartDrawer();
    }, 500);
  }

  function initProductPageFix() {
    // Фикс для desktop product page: анимация кнопки отсутствует,
    // поэтому animationend не стреляет и drawer не открывается.
    // Используем beforeAddItem/afterCartLoad напрямую.

    $(document.body).on('beforeAddItem.ajaxCart', function () {
      addingToCart = true;
    });

    $(document.body).on('afterCartLoad.ajaxCart', function () {
      if (!addingToCart) return;
      addingToCart = false;

      var isProductPage = document.body.classList.contains('template-product');
      var isQuickShopOpen = !!document.querySelector('.mfp-ready quick-shop');

      if (isProductPage && !isQuickShopOpen) {
        var showCart = document.body.dataset.quickShopShowCart === 'true';
        if (showCart) {
          setTimeout(function () {
            openCartDrawer();
          }, 150);
        }
      }
    });
  }

  function init() {

    initProductPageFix();

    document.addEventListener('click', function (e) {
      var trigger = e.target.closest(
        '.js-cart-draw .cart-sell .js-quickshop-trigger'
      );
      if (!trigger) return;

      var productCard = trigger.closest('.product-card');
      var qs = productCard && productCard.querySelector('quick-shop');
      if (!qs) return;

      e.stopImmediatePropagation();
      e.preventDefault();

      pendingQuickShopEl = qs;
      state = 'closing-cart';

      $.magnificPopup.close();

    }, true);

    $(document).on('mfpClose', function () {

      if (state === 'closing-cart' && pendingQuickShopEl) {
        var qs = pendingQuickShopEl;
        pendingQuickShopEl = null;
        state = 'quickshop-open';

        setTimeout(function () {
          qs.show();
          qs.addEventListener('closed.quickShop', onQuickShopClosed, { once: true });
        }, 120);

        return;
      }

      if (state === 'quickshop-open') {
        onQuickShopClosed();
      }

    });

  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})(jQuery);